/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";

export function SidebarLinks({ routes, onClose }) {
  const location = useLocation();
  const activeRoute = (routeName) => location.pathname.includes(routeName);

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      // ⛔️ Do not render hidden routes in sidebar
      if (route.hidden) return null;

      if (
        route.layout === "/admin" ||
        route.layout === "/auth" ||
        route.layout === "/rtl"
      ) {
        return (
          <Link
            key={index}
            to={route.layout + "/" + route.path}
            onClick={() => {
              // 🚀 AUTO CLOSE ONLY ON MOBILE
              if (window.innerWidth < 1280 && onClose) {
                onClose();
              }
            }}
          >
            <div className="relative mb-3 flex hover:cursor-pointer">
              <li className="my-[3px] flex cursor-pointer items-center px-8 ">
                <span
                  className={`${
                    activeRoute(route.path)
                      ? "font-bold text-red-500 dark:text-red-500 "
                      : "font-medium text-gray-500 "
                  }`}
                >
                  {route.icon ? route.icon : <DashIcon />}
                </span>

                <p
                  className={`leading-1 ml-4 flex ${
                    activeRoute(route.path)
                      ? "font-bold text-navy-700 dark:text-white "
                      : "font-medium text-gray-600"
                  }`}
                >
                  {route.name}
                </p>
              </li>
              {activeRoute(route.path) ? (
                <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-red-500 dark:bg-red-500" />
              ) : null}
            </div>
          </Link>
        );
      }
      return null;
    });
  };

  return createLinks(routes);
}

export default SidebarLinks;
